import WorkflowInstanceState from './OnPremWorkflowInstanceState';
import User from './User';
import { WorkflowType } from './enums/WorkflowType';

export default class WorkflowInstance {
	workflowType!: WorkflowType;

	owner!: User;

	createdDate!: Date;

	createdBy!: User;

	onPremWorkflowInstanceStates!: WorkflowInstanceState[];

	currentWorkflowInstanceState!: WorkflowInstanceState;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.onPremWorkflowInstanceStates = obj.onPremWorkflowInstanceStates?.map(state => new WorkflowInstanceState(state));
		this.currentWorkflowInstanceState = new WorkflowInstanceState(obj.currentWorkflowInstanceState);
		this.workflowType = new WorkflowType().fromValue(obj.workflowType?.value);
	}
}